// extracted by mini-css-extract-plugin
export var cluster = "styles-module--cluster--4a01f";
export var clusters = "styles-module--clusters--7f655";
export var container = "styles-module--container--bd2c6";
export var desktop = "1340px";
export var giant = "2200px";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1025px";
export var mobile = "400px";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var tablet = "769px";
export var threeCol = "styles-module--threeCol--cc9c4";
export var title = "styles-module--title--0db0e";